import { string, div, Action, stateful, mk_widget, async, button, nothing, loadingAsyncState, Widget, none, mkWidget } from 'widgets-for-react'
import * as Immutable from 'immutable';
import * as React from 'react'
import { Map, Marker, Popup, Tooltip } from 'react-leaflet'
import L from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'leaflet-providers';
import { MapsState, MapEntity, CategoriesList, MapSearchResult } from './maps_types';
import { provider, boundsOptions, center_rotterdam, generateMapEntity, getDistance, mocked_up_tile_provides, sample_MapStyling, update_selection_status, example_plus } from './maps_utils';
import { gtmPush } from '../../helpers';

const mapSearchForm = (s0: MapsState) =>
  mkWidget<Action<MapsState>>({
    run: (cont) => (
      <form
        onSubmit={(e) => {
          e.preventDefault()
          cont((s) => {
            debugger
            if (s.search_status.value == '') return s
            gtmPush({
              category: 'Locator',
              action: 'Search',
              label: s.search_status.value
            })
            return {
              ...s,
              search_status: {
                kind: 'search',
                value: s.search_status.value,
                async: s.default_search_function(s.search_status.value, s)
              },
              route_state: 'update'
            }
          })
        }}>
        {string({
          readonly: true,
          readonly_element: 'nothing',
          className: s0.styling.root__search__label
        })(s0.search_label)
          .never()
          .wrapHTML((elems) => (
            <label htmlFor="map-search-input" className="map-search__label typo--s">{elems}</label>
          ))
          .run(() => {})}
        {string({
          readonly: false,
          readonly_element: 'input',
          className: s0.styling.root__search__input,
          extraProperties: { placeholder: 'uw postcode of woonplaats' },
          id: 'map-search-input'
        })(s0.search_status.value)
          .map<Action<MapsState>>((a) => (s) => {
            return {
              ...s,
              search_status: { ...s.search_status, value: a },
              last_searched_center: a == '' ? 'none' : s.last_searched_center
            }
          })
          .run(cont)}
        <button
          className={s0.styling.root__search__button}
          disabled={s0.search_status.kind == 'search'}
          type="submit">
             <svg className={s0.styling.root__search__icon}  width="24px" height="12px" aria-hidden="true">
              <use xlinkHref="#icon--arrow" />
            </svg>
          </button>
      </form>
    )
  })

export let __private_presentation_kind = ""
export const maps_no_stateful = function(state:MapsState) : Widget<Action<MapsState>>{
  let data : CategoriesList  = state.data_to_display.kind == "list_category" ? state.data_to_display : {kind:"list_category", selected_category:"", categories:Immutable.List([{title:"", entities:state.data_to_display.entities}])}
  let _selected_category = data.categories.find(c => c.title == data.selected_category)
  let selected_category:{ title: string; entities: Immutable.List<MapEntity>; } | "none" = _selected_category == undefined ? "none" : _selected_category
  __private_presentation_kind = state.presentation_mode.value.kind
  return div<Action<MapsState>>({ className: state.styling.root, key: state.presentation_mode.value.kind })
  (div<Action<MapsState>>({ className: state.styling.root__inner})([
    state.header(state),
    div<Action<MapsState>>({className:state.styling.root__search})([
      state.search_status.kind == "search" ? async<MapSearchResult>()(state.search_status.async).map<Action<MapsState>>(a => s => {
        if(s.search_status.kind == "input") return s
        let a1 = a(s.search_status.async)
        if(a1.kind == "loaded"){

          if(a1.value.centers.length > 0){
            let new_center = a1.value.centers[0]
            let y = +new_center.y
            let x = +new_center.x
            let point = new L.LatLng(Number.isNaN(y) ? 0 : y, Number.isNaN(x) ? 0 : x)
            let zoom_options : L.ZoomPanOptions =  {animate:false}

            if(s.map != "none"){
              s.map.leafletElement.setView(point, 14, zoom_options)
            }
            let new_data_to_display = s.data_to_display

            if(a1.value.new_data.v.kind == "r"){
              new_data_to_display = a1.value.new_data.v.v
            }

            return {...s, search_status:{...s.search_status, kind:"input", value:s.search_status.value}, 
                          center_marker:s.center_marker ? {...s.center_marker, position:point} : undefined,
                          data_to_display:new_data_to_display,
                          last_searched_center:point,
                          optional_bounds:selected_category == "none" ? [] : 
                                          selected_category.entities.map(p => ([p.position.lat, p.position.lng] as [number, number]))
                                                                    .filter(p => getDistance({lat:p[1], lng:p[0]}, point) < 5000)
                                                                    .toArray()
                    }
          }
          else{
            alert("Invalid search input")
          }
          return {...s, search_status:{kind:"input", value:s.search_status.value}}
        }
        return {...s, search_status:{...s.search_status, async:a1}}
      }) : nothing(),
      mapSearchForm(state)
    ]),
    state.presentation_mode.value.kind != "show list" && selected_category != "none" ?
      mk_widget({
        run: (set_state:(_:Action<MapsState>) => void) => {

          let bounds : L.LatLngBoundsExpression = state.optional_bounds
          //selected_category == "none" ? [] : selected_category.entities.map(p => ([p.position.lat, p.position.lng] as [number, number])).toArray()

          let _input_markers = selected_category == "none" ? null : 
            selected_category.entities
          // .filter(e => {
          //   if(state.map == "none") return false
          //   let res = state.map.leafletElement.getBounds().contains(e.position)
          //   return true
          // })
            .toArray()
          
          let input_markers = _input_markers
            .map(e => {
            return <Marker  
                          icon={e.icon(e)} 
                          state={e.selection_status}
                          position={e.position} 
                          onpopupclose={(): void => 
                            {
                              if(state.presentation_mode.value.kind != __private_presentation_kind) return
                              update_selection_status(set_state, state.data_to_display, e, "none")
                            }}
                          onmouseover={(event: L.LeafletMouseEvent): void => !(e.selection_status == "selected_in_list" || e.selection_status == "selected_on_map" ) ? update_selection_status(set_state, state.data_to_display, e, "hovered_on_map") : null}
                          onmouseout={(event: L.LeafletMouseEvent): void => !(e.selection_status == "selected_in_list" || e.selection_status == "selected_on_map" ) ? update_selection_status(set_state, state.data_to_display, e,"none") : null}
                          onclick={(event: L.LeafletMouseEvent): void => update_selection_status(set_state, state.data_to_display, e,"selected_on_map")}
                          >
              {e.show_info_on_map == "on_click" ? 
                <Popup>
                  {e.info_when_on_map(e)}
                </Popup> : 
                <Tooltip direction="bottom">
                  {e.info_when_on_map(e)}
                </Tooltip>}
            </Marker>
          })
          
          return <div className={state.styling.root__map}>
              <Map ref={map => {
                          if(map != undefined && state.map == "none") {
                            let found_provider = false
                            state.map_tile_provider.list_tile_provides.forEach(p => {
                              if(p.name == state.map_tile_provider.default_tile_provider){
                                p.apply(map.leafletElement)
                                found_provider = true
                              }
                            })
                            if(!found_provider){
                              L.tileLayer.provider('OpenStreetMap.Mapnik').addTo(map.leafletElement)
                            }
                            set_state(s => {
                              // console.log('set map')
                              let zoom = map.leafletElement.getZoom()
                              let center = s.last_searched_center != "none" ? s.last_searched_center : s.default_center
                              let center_marker = s.center_marker ? {...s.center_marker, position:center} : s.center_marker

                              map.leafletElement.setView(center, zoom ? zoom : 12, {animate:false})

                              return {...s, map, last_center_on_map:center, center_marker}
                            })
                          }
                        }}    
                        preferCanvas={true}
                        onresize={e => {
                          set_state(s => {
                            if(s.map == "none") return s
                            let center = s.map.leafletElement.getCenter()
                            return {...s, last_event:e, 
                                // current_center: center, 
                                // internal_prev_center:s.current_center, 
                                last_center_on_map:center,
                                center_marker:s.center_marker?{...s.center_marker, position:center}:null}
                          })
                        }}
                        //center={state.current_center}                         
                        bounds={bounds && bounds.length == 0 ? undefined : bounds}
                        boundsOptions={boundsOptions}
                        maxZoom={18}
                        onmoveend={
                          e => {

                            if(state.map == "none") return
                            
                            looping += 1

                            if(looping > 1){
                              return 
                            }
                            //move end generates too many events when solving popup positions

                            let try_sleep = (last_loop) =>
                              setTimeout(() => {
                                if(last_loop == looping){
                                  if (looping == 1) {
                                    looping = 0
                                    return
                                  }
                                  looping = 0
                                  if(state.map == "none") return

                                  let center = state.map.leafletElement.getCenter()
                                  if(state.last_center_on_map != "none")
                                    if(getDistance(center, state.last_center_on_map) == 0) return

                                  set_state(s => {
                                    if(s.map == "none") return s
                                    let center = s.map.leafletElement.getCenter()
                                    return {...s, last_event:e,
                                                  last_center_on_map:center,
                                                  center_marker:s.center_marker?{...s.center_marker, position:center}:null}
                                  })
                                }
                                else{
                                  try_sleep(looping)
                                }
                              }, 100)
                            try_sleep(looping)
                            
                          }
                        }

                        onzoomend={
                          e => {
                            if(state.map == "none") return
                            if(looping > 0){
                              return
                            }
                            set_state(s => {
                              if(s.map == "none") return s
                              let zoom = s.map.leafletElement.getZoom()
                              let center = s.map.leafletElement.getCenter()
                              return {...s, last_event:e, current_zoom: zoom, 
                                            last_center_on_map:center,
                                            center_marker:s.center_marker?{...s.center_marker, position:center}:null}
                            })
                        }
                      }
                        >
                <MarkerClusterGroup
                  showCoverageOnHover={false}
                  removeOutsideVisibleBounds={true}
                  key={`${state.internal_cluster_key} - ${input_markers ? _input_markers.length : 0}`}
                  iconCreateFunction={state.styling.cluster_styling(state.data_to_display)}>
                {input_markers}
                </MarkerClusterGroup>
                {/* {state.center_marker ? <Marker  position={state.center_marker.position} icon={state.center_marker.icon(state.center_marker)}/> : null}                       */}
              </Map>
            </div>
        }
      }) : nothing(),
    state.presentation_mode.value.kind == "show list and map" || state.presentation_mode.value.kind == "show list" ?
      div<Action<MapsState>>({className:state.styling.root__list})([
        // div<Action<MapsState>>({className:state.styling.root__list__header})([
        //   hn(2,state.list_title,{readonly:true, className:state.styling.root__list__title})().never(),
        // ]),
        div<Action<MapsState>>({className:state.styling.root__list__content})(
          selected_category == "none" ? 
            [string({readonly:true, readonly_element:"p"})("No data to display. Select a category first.").never()] :
          selected_category.entities.sort((a, b) =>
              {
                let center = state.presentation_mode.value.kind == "show list" && state.last_searched_center != "none" 
                              ? state.last_searched_center 
                              : state.center_marker != undefined ? state.center_marker.position
                              : center_rotterdam
                let a_dist = getDistance(center, a.position)
                let b_dist = getDistance(center, b.position)
                // let random = Math.random()
                if(state.presentation_mode.value.kind == "show list" && state.last_searched_center == "none"){
                //   if(random < 0.33) return b_dist - a_dist
                //   if(random < 0.66) return a_dist - b_dist
                  return 0
                }
                return a_dist - b_dist
              }
            ).map((e):Widget<Action<MapsState>> => {
            let widget:Widget<Action<MapsState>> = mk_widget({
              run: set_state => {
                return <article 
                            className={state.styling.root__list__item}
                            // onMouseOver={() => !(e.selection_status == "selected_in_list" || e.selection_status == "selected_on_map" ) ? update_selection_status(set_state, state.data_to_display, e, "hovered_in_list") : null}
                            // onMouseOut={() => !(e.selection_status == "selected_in_list" || e.selection_status == "selected_on_map" ) ? update_selection_status(set_state, state.data_to_display, e,"none") : null}
                            // onClick={() => update_selection_status(set_state, state.data_to_display, e,"selected_in_list")}
              >{e.info_when_on_list(e, state.presentation_mode)}</article> 
              }})
              
            if(state.presentation_mode.value.kind == "show list"){ 
              let center = state.last_searched_center != "none" ? state.last_searched_center : state.default_center//state.map.leafletElement.getCenter()
              if(getDistance(center, e.position) <= state.presentation_mode.value.current_range)
                return widget              
            }
            if(state.map == "none") return nothing()
            let getBounds = state.map.leafletElement.getBounds()
            if(getBounds.contains(e.position)) 
              //return string()(`${getDistance(state.current_center, m.position)}`).never()
              return widget 
            return nothing<Action<MapsState>>()
          }).toArray().concat([
            state.presentation_mode.value.kind == "show list" 
              ?  button<Action<MapsState>>(`load more`,
                  { className:state.styling.root__list__content__add_more_items })
                  (() => s => {
                    if(s.presentation_mode.value.kind != "show list") return s
                    return {...s,  presentation_mode:{...s.presentation_mode, value:{...s.presentation_mode.value, current_range:s.presentation_mode.value.current_range + s.presentation_mode.delta_increase_range_value}}}
                  })
              : nothing()
          ]),            
        )
      ]) : nothing()
  ]))
}
let looping = 0
export const maps = function(init_state:MapsState){
  return stateful<MapsState>()(
    state => maps_no_stateful(state).map((action:Action<MapsState>) => {
      let s1 = action(state)
      // console.log("new state", s1)
      return s1
    })
  )(init_state)
}

export let sample1_initial_state : MapsState = {
  route_state:"none",
  last_searched_center:"none",
  last_center_on_map:"none",
  list_title: "",
  search_label: "",
  internal_cluster_key:0,
  map_tile_provider:{
    default_tile_provider:"OpenStreetMap.Mapnik",
    list_tile_provides:mocked_up_tile_provides
  },
  default_center:center_rotterdam,
  data_to_display: {kind:"simple_list", entities:generateMapEntity(center_rotterdam, 2000, 50)},
  header:(state:MapsState) => mk_widget({
    run: set_state => {
      return <div>
        <div>
          <p>Map style:</p>
          <div className="dropdown">
            <button className="btn btn-secondary dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {state.map_tile_provider.default_tile_provider == "" ? '<default>' : state.map_tile_provider.default_tile_provider}
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {
                state.map_tile_provider.list_tile_provides.map(p => {
                  return <a className="dropdown-item" onClick={() => {
                      state.map != "none" && p.apply(state.map.leafletElement)
                      set_state(s => ({...s, map_tile_provider:{...s.map_tile_provider, default_tile_provider:p.name}})) }
                  } href="#">{p.name}</a>
                })
              }
            </div>
          </div>
        </div>
        <div>
          <p>Presentation mode:</p>
          <div className="btn-group" role="group" aria-label="Basic example">
            <button className="btn btn-info" onClick={() => 
                set_state(s => ({...s, presentation_mode:{...s.presentation_mode, value:{kind:"show list", current_range:s.presentation_mode.default_list_range}}, map:"none"}))}>Show only list</button>
            <button className="btn btn-info" onClick={() => 
                set_state(s => ({...s, presentation_mode:{...s.presentation_mode, value:{kind:"show list and map"}}}))}>Show list and map</button>
            <button className="btn btn-info" onClick={() => 
                set_state(s => ({...s, presentation_mode:{...s.presentation_mode, value:{kind:"show map"}}}))}>Show only map</button>
          </div>
        </div>
      </div>
    }}),
  last_event:"none",
  map:"none",
  max_zoom:19,
  presentation_mode:{value:{kind:"show list and map"}, default_list_range:500, delta_increase_range_value:500 },
  default_search_function:(input:string, state:MapsState) => {
    return loadingAsyncState(async () => {
      let results = await provider.search({ query: input });
      //success update url
      return { kind:"result",status:200,value: {centers:results, new_data:none()} as MapSearchResult }
    })
  },
  search_status:{kind:"input", value:""},
  // current_zoom:14,
  styling:sample_MapStyling
}


export let sample2_initial_state = (categories:Immutable.List<{title:string, entities:Immutable.List<MapEntity>}>) : MapsState => {
  return { ...sample1_initial_state, 
    center_marker:{
      position:sample1_initial_state.default_center,// sample1_initial_state.current_center,
      icon: _ => example_plus
    },
    data_to_display: {kind:"list_category",  selected_category:"", categories},
    header:(state:MapsState) => mk_widget({
      run: set_state => {
        return <div>
          <div>
            <p>Map style:</p>
            <div className="dropdown">
              <button className="btn btn-secondary dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {state.map_tile_provider.default_tile_provider == "" ? '<default>' : state.map_tile_provider.default_tile_provider}
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {
                  state.map_tile_provider.list_tile_provides.map(p => {
                    return <a className="dropdown-item" onClick={() => {
                        state.map != "none" && p.apply(state.map.leafletElement)
                        set_state(s => ({...s, map_tile_provider:{...s.map_tile_provider, default_tile_provider:p.name}})) }
                    } href="#">{p.name}</a>
                  })
                }
              </div>
            </div>
          </div>
          <div>
            <p>Presentation mode:</p>
            <div className="btn-group" role="group" aria-label="Basic example">

              <button 
                className="btn btn-info" 
                onClick={() => 
                  set_state(s => ({
                    ...s, 
                    presentation_mode: {
                      ...s.presentation_mode, 
                      value: { 
                        kind:"show list", 
                        current_range:s.presentation_mode.default_list_range
                      }
                    }, 
                    map:"none"
                  })
                )}
              >
                Show only list
              </button>

              <button 
                className="btn btn-info" 
                onClick={() => 
                  set_state(s => ({
                    ...s, 
                    presentation_mode: {
                      ...s.presentation_mode, 
                      value: {
                        kind:"show list and map" 
                      }
                    }
                  })
                )}
              >
                Show list and map
              </button>

              <button 
                className="btn btn-info" 
                onClick={() => 
                  set_state(s => ({
                    ...s, 
                    presentation_mode: {
                      ...s.presentation_mode, 
                      value: { 
                        kind:"show map" 
                      }
                    }
                  })
                )}
              >
                Show only map
              </button>

            </div>
          </div>
          <div>
            <p>Category:</p>
            <div className="btn-group" role="group" aria-label="Basic example">
              {
                categories.map(c => {
                  return <button className="btn btn-info" onClick={() => set_state(s => {
                    if(s.data_to_display.kind == "simple_list") return s
                    return {...s, data_to_display:{...s.data_to_display, selected_category:c.title}, map:"none"}
                  })}>{c.title}</button>
                })
              }
            </div>
          </div>
        </div>
      }})
    }
  }
  

// export let mapsExample: Sample = ({
//   widget: () => maps(sample2_initial_state(mocked_up_categories)),
//   // widget: () => maps(sample1_initial_state),
//   path: "/examples/maps",
//   name: "Maps",
//   category: "maps",
//   documentation: function () {
//     return {
//       ...mk_MarkupContent("Markdown"), text: `# Maps

// This sample shows a map sample made with the open maps library and React-Leaflet.`
//     }
//   }
// })


// WEBPACK FOOTER //
// ./Client/components/map/maps.tsx